import script from "./FormAgentComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormAgentComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormAgentComponent.vue?vue&type=style&index=0&id=700f555c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-700f555c"]])

export default __exports__